import { createApp } from 'vue'
import App from '@/App.vue'
import registerPlugin from '@/plugins/index'
import store from '@/store/store'
import router from './router'
import registerCompoent from '@/components/index'
import '@/assets/style/common.less'
import 'virtual:svg-icons-register'
import registerGlobalProperties from '@/plugins/globalProperties'
import { loadMonitorSDK } from '@/utils/monitor'
import { initVolcAnalytics } from '@/utils/volcAnalytics'

const app = createApp(App)
const packageList = [store, router, registerCompoent]
packageList.forEach((p) => app.use(p))
//按需注册全局组件
registerPlugin(app)
registerGlobalProperties(app)
// 加载Bonree APM监控SDK
loadMonitorSDK({
  data: '%7B%22reqHeaderTraceKey%22%3A%5B%22tracestate%22%2C%22traceparent%22%5D%2C%22pendingRequestTimeout%22%3A30000%2C%22uploadAddrHttps%22%3A%22https%3A%2F%2Fjmsmy-bonree-apm.jtexpress.my%2FRUM%2Fupload%22%2C%22probability%22%3A1000%2C%22mc%22%3A%5B%7B%22n%22%3A%22network%22%2C%22cs%22%3A%7B%22fc%22%3A0%7D%7D%5D%2C%22appId%22%3A%22e9a689deccfd4d0f88d5d3bce586fabd%22%2C%22uploadAddrHttp%22%3A%22http%3A%2F%2Fjmsmy-bonree-apm.jtexpress.my%2FRUM%2Fupload%22%2C%22hcs%22%3A2%2C%22respHeaderTraceKey%22%3A%5B%22traceresponse%22%2C%22x-br-response%22%5D%2C%22brss%22%3Afalse%7D'
})

// 火山引擎 DataFinder 埋点（配置由环境变量注入，见 vitePlugin/env/my/.env.*）
const volcAppId = import.meta.env.VITE_VOLC_APP_ID
const volcChannelDomain = import.meta.env.VITE_VOLC_CHANNEL_DOMAIN
const volcSdkUrl = import.meta.env.VITE_VOLC_SDK_URL
if (volcAppId && volcChannelDomain && volcSdkUrl) {
  initVolcAnalytics({
    app_id: Number(volcAppId),
    channel_domain: volcChannelDomain,
    sdk_path: volcSdkUrl
  })
}

app.mount('#app')
